module.exports = __webpack_public_path__ + "static/nlp-6a233a3647992083214244bfb78cdafe.jpeg";